







































































































































import { Vue, Component, Watch } from "vue-property-decorator";
import { Widget as IWidget } from "@/api/models/widget";
import { Employee as IEmployee } from "@/api/models/employee";
import { CoursesList as ICoursesList } from "@/api/models/courses-list";
import { Course as ICourse } from "@/api/models/course";
import { VideoList as IVideoList } from "@/api/models/video-list";
import { Video as IVideo } from "@/api/models/video";
import { WebinarList as IWebinarList } from "@/api/models/webinar-list";
import { Webinar as IWebinar } from "@/api/models/webinar";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import api from "@/getinfo-api";
import DeleteMaterialModal from "@/components/form/DeleteMaterialModal.vue";
import CBreadCrumbs from "@/components/form/CustomPage/CBreadCrumbs.vue";

@Component({ components: { CBreadCrumbs, DeleteMaterialModal } })
export default class Widget extends Vue {
  widget: IWidget | any;
  employee!: IEmployee;
  courses: Array<ICourse> = [];
  videos: Array<IVideo> = [];
  webinars: Array<IWebinar> = [];
  showRemoveModal: boolean = false;

  data() {
    return {
      widget: undefined,
      employee: undefined
    };
  }

  get breadcrumbs() {
    return [
      {
        to: { name: "apiKeysMain" },
        label: `${this.$tc(this.$translate.Integration)}`
      },
      {
        label: this.$converter.limitedOutput(this.widget.title, 40)
      }
    ];
  }

  @Watch("currentCompany")
  checkCompany() {
    this.getEmployee();
  }

  get currentCompany() {
    return this.$store.getters.selectedCompany;
  }

  getWidget() {
    if (this.$route && this.$route.params && this.$route.params.id) {
      api.WidgetApi.get(this.$route.params.id)
        .then((res: { data: IWidget }) => {
          this.widget = res.data;
          this.getCourses();
          this.getRecords();
          this.getWebinars();
          this.getEmployee();
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        });
    }
  }

  getEmployee() {
    // @ts-ignore
    if (
      // @ts-ignore
      this.widget?.settings?.responsibleId &&
      // @ts-ignore
      this.widget?.settings?.companyId
    ) {
      api.EmployeeApi.get(
        // @ts-ignore
        this.widget?.settings?.companyId,
        // @ts-ignore
        this.widget.settings.responsibleId
      )
        .then((res: { data: IEmployee }) => {
          this.employee = res.data;
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        });
    }
  }

  getCourses() {
    // @ts-ignore
    if (this.widget?.settings?.courses?.length) {
      // @ts-ignore
      api.CourseApi.list(this.widget?.settings?.courses)
        .then((res: { data: ICoursesList }) => {
          this.courses = res.data.courses;
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        });
    }
  }

  getRecords() {
    // @ts-ignore
    if (this.widget?.settings?.records?.length) {
      // @ts-ignore
      api.VideoApi.list(this.widget.settings.records)
        .then((res: { data: IVideoList }) => {
          this.videos = res.data.videos;
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        });
    }
  }

  getWebinars() {
    // @ts-ignore
    if (this.widget?.settings?.webinars?.length) {
      // @ts-ignore
      api.WebinarApi.list(this.widget.settings.webinars)
        .then((res: { data: IWebinarList }) => {
          this.webinars = res.data.webinars;
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        });
    }
  }

  mounted() {
    this.getWidget();
    if (this.currentCompany) this.getEmployee();
  }
}
